import React, { useEffect } from 'react';
import { Form, FormInstance, SelectBooleanInput } from 'blueprint-form';
import { Row, Col } from '../../../../grid';
import { CardBlock } from '../../../organisms/card';

interface EpxWellMgmtSettingsData {
  afterHourInfo?: boolean;
}

const DefaultSettings: EpxWellMgmtSettingsData = {
  afterHourInfo: false
};

interface EpxWellMgmtSettingsProps {
  setForm?: (form: FormInstance<EpxWellMgmtSettingsData>) => void;
  onSubmit?: (data: EpxWellMgmtSettingsData) => void;
  disabled?: boolean;
}

const EpxWellMgmtSettings = ({
  setForm,
  onSubmit: _onSubmit,
  disabled
}: EpxWellMgmtSettingsProps): JSX.Element => {
  const form = new FormInstance<EpxWellMgmtSettingsData>(DefaultSettings);
  useEffect(() => {
    if (setForm) {
      setForm(form);
    }
  }, []);
  const onSubmit = (data: EpxWellMgmtSettingsData) => {
    _onSubmit({
      ...data
    });
  };
  return (
    <CardBlock bare>
      <Form form={form} onSubmit={onSubmit}>
        <CardBlock>
          <Row>
            <Col sm={12}>
              <SelectBooleanInput
                label="Inform Business Hour"
                name="afterHourInfo"
                fill
                disabled={disabled}
              />
            </Col>
          </Row>
        </CardBlock>
      </Form>
    </CardBlock>
  );
};

export default EpxWellMgmtSettings;
